<template>
  <div class="container">
    <h1 class="title is-4 mb-6">
      {{ $t("assistant module settings") }}
    </h1>

    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">
            {{ $t("jwt key") }}
          </label>
          <div class="control">
            <input
              class="input"
              type="text"
              :placeholder="$t('jwt key')"
              v-model="meta.jwt_key"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">
                {{ $t("expire time") }}
              </label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder="10, 5"
                  v-model="meta.expire_time"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">
                {{ $t("time unit") }}
              </label>
              <div class="select is-fullwidth">
                <select v-model="meta.expire_time_unit">
                  <option value="d">{{ $t("days") }}</option>
                  <option value="h">{{ $t("hours") }}</option>
                  <option value="m">{{ $t("minutes") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <div class="title is-6">{{ $t("integrate assistant") }}</div>
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_assistant"
            name="chk_integrate_assistant"
            v-model="meta.integrate_assistant"
          />
          <label for="chk_integrate_assistant">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">
            {{ $t("api key for sdk") }}
          </label>
          <div class="control">
            <input
              class="input"
              type="text"
              :placeholder="$t('api key')"
              v-model="meta.sdk_api_key"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('default assistant')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/assistant/personality/catalog"
            name_field="name"
            value_field="personality_id"
            @selected="personality_changed"
            ref="personality_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">
            {{ $t("default options") }}
          </label>
          <div class="control">
            <input
              class="input"
              type="text"
              :placeholder="$t('api key')"
              v-model="meta.sdk_default_options"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="columns">
      <personality-datatable ref="personality_datatable" />
    </div> -->

    <!-- <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("account module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_every_customer_has_account"
            name="chk_every_customer_has_account"
            v-model="meta.every_customer_has_account"
          />
          <label for="chk_every_customer_has_account">{{
            $t("every customer has an account")
          }}</label>
          <div
            class="button is-rounded is-primary is-small"
            @click="check_customer_account_existance"
          >
            <span class="icon"><i class="fa fa-check"></i></span>
            <span>{{ $t("check") }}</span>
          </div>
        </div>
      </div>
    </div> -->

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import PersonalityDatatable from "./personality_datatable/Index.vue";

export default {
  name: "AssistantSettings",
  components: { GenericDropdown, PersonalityDatatable },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    personality_changed(personality) {
      let v = this;
      if (personality) {
        v.meta.default_assistant_id = personality.personality_id;
        v.meta.default_assistant_uuid = personality.uuid;
      }
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;
          if (conf.default_assistant_id)
            v.$refs.personality_dropdown.set_value(conf.default_assistant_id);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
